// Fallback only — used when the Fees module's overview call fails (e.g. no
// fee structures configured yet for this institution). See
// dashboardService.loadFeesOverview.
export const feesOverview = {
  collected: '₹0',
  expected: '₹0',
  percent: 0,
};

// Quick-action shortcuts — static by design (not data from any endpoint).
export const quickLinks = [
  { label: 'institutionAdmin.dashboard.quick.addStudent', iconKey: 'user-plus', tone: 'blue', route: 'ADMISSIONS_NEW' },
  { label: 'institutionAdmin.dashboard.quick.takeAttendance', iconKey: 'check-square', tone: 'orange', route: 'ATTENDANCE' },
  { label: 'institutionAdmin.dashboard.quick.collectFees', iconKey: 'credit-card', tone: 'rose', route: 'FEES' },
  { label: 'institutionAdmin.dashboard.quick.viewStudents', iconKey: 'users', tone: 'purple', route: 'STUDENTS' },
] as const;
